import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '../../GridRenderer/actionRendere'
import ListRenderer from '@/components/DynamicComponents/Renderers/keywordRenderer'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import CommentsRenderer from '@/components/DynamicComponents/Renderers/commentsRenderer'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import TagsRenderer from '@/components/DynamicComponents/Renderers/tagRenderer'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Contract'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import { createRequest, tableName } from '@/services/config'

export default {
  components: {
    importTemplates,
    exportTemplates,
    'ag-grid-vue': AgGridVue,
    Pagination,
    ContractComponent,
  },
  props: {
    tabKey: String,
    isAddCategory: Boolean,
    type: String,
    columnSettings: Array,
    screenId: Number,
    isArchive: Boolean,
  },
  data: function () {
    const checTextkLength = (rule, value, callback) => {
      if (rule.field === 'notes') {
        if (String(value).length > 200) {
          callback(
            new Error('Notes must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'categoryCode') {
        if (String(value).length > 6) {
          callback(
            new Error('Category code must be less than or equals to 6 digits'),
          )
        } else {
          callback()
        }
      } else {
        let field = 'Contract name'
        if (rule.field === 'description') {
          field = 'Description'
        }
        if (String(value).length > 100) {
          callback(
            new Error(field + ' must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      }
    }
    return {
      exportClicked: false,
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'categoryCode',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      propertyUnitList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        categoryCode: undefined,
        eligible: false,
        assetClass: undefined,
        assetClassId: undefined,
        mAssetClassId: undefined,
        bsuopDetailsId: undefined,
        mBsuopDetailsId: undefined,
        description: undefined,
        notes: undefined,
        keywords: undefined,
        keywordList: [],
        isActive: 1,
        contractDetailsId: undefined,
        mContractDetailsId: undefined,
        contract: undefined,
        bsuopName: undefined,
        assetClassName: undefined,
      },
      rules: {
        contract: [
          {
            required: true,
            message: 'Please select contract',
            trigger: 'change',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: 'Please enter category code',
            trigger: 'blur',
          },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        assetClassName: [
          {
            required: true,
            message: 'Please select asset class',
            trigger: 'change',
          },
        ],
        bsuopName: [
          { required: true, message: 'Please select bsuop', trigger: 'change' },
        ],
        description: [
          {
            required: true,
            message: 'Please enter description',
            trigger: 'blur',
          },
          { validator: checTextkLength, trigger: 'blur' },
        ],
      },
      assetClassList: [],
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      uploadedFile: null,
      importClicked: false,
      importColDef: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Category Code',
          field: 'CategoryCode',
          width: 120,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Description',
          field: 'Description',
          tooltipField: 'Description',
          width: 250,
        },
      ],
      loadImport: false,
      filters: {},
      bsuopList: [],
      contractList: [],
      isAddContract: false,
      updateRequest: null,
      requestKeys: [
        'mAssetClassId',
        'mContractDetailsId',
        'mBsuopDetailsId',
        'categoryCode',
        'description',
        'eligible',
        'notes',
        'keywords',
        'isActive',
      ],
      contracts: [],
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Contract #',
          field: 'contract',
          width: 75,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          headerTooltip: 'Contract #',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Contract',
          field: 'contractName',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          headerTooltip: 'Contract',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Category Code',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          headerTooltip: 'Description',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          headerTooltip: 'Asset Class',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'BSUOP',
          field: 'bsuop',
          width: 75,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          filter: 'customFilter',
          headerTooltip: 'BSUOP',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'BSUOP Description',
          field: 'bsuopDescription',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          headerTooltip: 'BSUOP Description',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: '179 Eligible',
          field: 'eligible',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: '179 Eligible',
          cellRenderer: 'tagsRenderer',
          menuTabs: [],
          tooltipValueGetter: params => {
            return params.data.eligible ? 'Yes' : 'No'
          },
        },
        {
          headerName: 'Notes',
          field: 'notes',
          width: 50,
          sortable: false,
          floatingFilter: false,
          cellRenderer: 'commentsCellRenderer',
          headerTooltip: 'Notes',
          cellRendererParams: { title: 'Notes' },
          menuTabs: [],
        },
        {
          headerName: 'Keywords',
          field: 'keywords',
          width: 250,
          cellRenderer: 'keywordsCellRenderer',
          sortable: false,
          floatingFilter: false,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          suppressSizeToFit: true,
          headerTooltip: 'Keywords',
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Category Code',
            edit: true,
            delete: true,
          },
          pinned: 'right',
        },
      ],
    }
  },
  beforeMount() {
    if (this.isAddCategory) {
      this.contracts = []
      this.addNew()
    }
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
    if (!this.isArchive) {
      this.getAssetClasses()
      this.getBSUOP()
      this.getContract()
    }
  },
  mounted() {
    this.$root.$on('deleteCategoryCode', this.deleteCategoryCode)
    this.$root.$on('editCategoryCode', this.getCategoryCodeById)
    window.addEventListener('resize', this.getWindowSize)
  },
  beforeDestroy() {
    this.$root.$off('deleteCategoryCode')
    this.$root.$off('editCategoryCode')
    this.$off('updateTableData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '8') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.propertyUnitList = []
        this.loading = true
        this.defaultSortedBy = 'categoryCode'
        this.defaultSortOrder = true
        // this.gridOptions.columnApi.applyColumnState({
        //   state: [
        //     {
        //       colId: 'categoryCode',
        //       sort: 'asc',
        //     },
        //   ],
        //   defaultState: { sort: null },
        // })
        if (!this.isArchive) {
          this.getAssetClasses()
          this.getBSUOP()
          this.getContract()
        }
        this.getCategoryCodes(this.tableParams)
      }
    },
  },
  methods: {
    loadingConfig() {
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        keywordsCellRenderer: ListRenderer,
        checkboxCellRender: CheckboxRender,
        commentsCellRenderer: CommentsRenderer,
        customFilter: CustomFilter,
        tagsRenderer: TagsRenderer,
        toolTipRenderer: ToolTipRenderer,
      }
    },

    // Refresh Category Codes
    refreshCategoryCodes() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.propertyUnitList = []
      this.page = 0
      this.defaultSortedBy = 'categoryCode'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'categoryCode',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getCategoryCodes(this.tableParams)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      if (this.isAddCategory) {
        this.$emit('addCategory', null, this.contracts, false)
      }
      this.contracts = []
    },

    // Add New Category Code
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Category Code'
      this.form.id = undefined
      this.form.keywordList = []
      this.isActive = 1
      this.form.mContractDetailsId = undefined
      this.form.mBsuopDetailsId = undefined
      this.form.mAssetClassId = undefined
      this.form.contractDetailsId = undefined
      this.form.bsuopDetailsId = undefined
      this.form.assetClassId = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Delete Category Code
    deleteCategoryCode(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.categoryCode}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this category
              code
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Save Category Code
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.form.keywords = this.form.keywordList.join(',')
          if (this.form.id) {
            this.updateCategoryCode()
          } else {
            this.addCategoryCode()
          }
        }
      })
    },

    // Get Category Codes
    getCategoryCodes(params, type) {
      if (!this.isAddCategory) {
        const req = {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          contract: _.get(this.filters, 'contract', undefined),
          contractName: _.get(this.filters, 'contractName', undefined),
          categoryCode: _.get(this.filters, 'categoryCode', undefined),
          description: _.get(this.filters, 'description', undefined),
          assetClass: _.get(this.filters, 'assetClass', undefined),
          bsuop: _.get(this.filters, 'bsuop', undefined),
          bsuopDescription: _.get(this.filters, 'bsuopDescription', undefined),
          keywords: _.get(this.filters, 'keywords', undefined),
        }
        instance
          .post(
            projectAPIs.master.categoryCode.list(this.$route.params.id),
            req,
          )
          .then(response => {
            this.propertyUnitList = _.get(response.data, 'result', [])
            this.count = _.get(response.data, 'totalCount', 0)
            this.height = calculateGridHeight(
              'proprtyUnitTable',
              this.count > this.pageSize,
            )
            this.loading = false
            this.loadRefresh = false
            if (type === 'sort') {
              this.updateColumnSetting()
            } else {
              this.getColumnSettings(params)
            }
          })
          .catch(error => {
            this.loading = false
            this.loadRefresh = false
            errorService(error)
          })
      }
    },

    // Get Category Codes
    getCategoryCodeById(id) {
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      instance
        .get(projectAPIs.master.categoryCode.details(this.$route.params.id, id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', undefined)
          this.form.description = _.get(
            response.data,
            'result.description',
            undefined,
          )
          this.form.notes = _.get(response.data, 'result.notes', null)
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.form.eligible = _.get(response.data, 'result.eligible', false)
          this.form.assetClass = _.get(
            response.data,
            'result.assetClass',
            undefined,
          )
          this.form.mAssetClassId = _.get(
            response.data,
            'result.mAssetClassId',
            undefined,
          )
          this.form.mBsuopDetailsId = _.get(
            response.data,
            'result.mBsuopDetailsId',
            undefined,
          )
          this.form.categoryCode = _.get(
            response.data,
            'result.categoryCode',
            undefined,
          )
          this.form.mContractDetailsId = _.get(
            response.data,
            'result.mContractDetailsId',
            undefined,
          )
          this.form.bsuopName = `${Number(
            _.get(response.data, 'result.bsuop', undefined),
          )} - ${_.get(response.data, 'result.bsuopDescription', undefined)}`
          this.form.assetClassName = `${
            this.assetClassList.find(i => i.id === this.form.mAssetClassId)
              .value
          }`
          this.form.contract = `${Number(
            _.get(response.data, 'result.contract', undefined),
          )} - ${_.get(response.data, 'result.contractName', undefined)}`
          if (response.data.result.keywords) {
            this.form.keywordList = _.get(
              response.data,
              'result.keywords',
              [],
            ).split(',')
          } else {
            this.form.keywordList = []
          }
          this.updateRequest = _.get(response.data, 'result', null)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(
          projectAPIs.master.categoryCode.delete(this.$route.params.id),
          {
            data: ids,
          },
        )
        .then(response => {
          showNotification(
            'success',
            'Delete Category Code',
            'Category Code deleted successfully!',
          )
          this.refreshCategoryCodes()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Add Keywords
    addKeywords($event) {
      if ($event.target.value && $event.target.value.trim()) {
        const present = this.form.keywordList.find(
          i => i.toLowerCase() === $event.target.value.toLowerCase(),
        )
        if (!present) {
          this.form.keywordList.push($event.target.value)
        }
        this.form.keyword = null
      } else {
        this.form.keyword = null
      }
    },

    // Remove Keywords
    removeKeywords(index) {
      this.form.keywordList.splice(index, 1)
    },

    // Asset Class List
    getAssetClasses() {
      instance
        .get(projectAPIs.dropdown.list(this.$route.params.id, 'asset-class'), {
          asset_class: 0,
        })
        .then(response => {
          this.assetClassList = []
          this.assetClassList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    onChange(checked) {
      this.form.eligible = checked
    },

    // exportClicked
    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    // Delete All Category Codes
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected property units ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              category codes
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.propertyUnitList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'categoryCode'
        this.defaultSortOrder = true
      }
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.getCategoryCodes(this.tableParams, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    updateTable() {
      this.importClicked = false
      this.refreshCategoryCodes()
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshCategoryCodes()
      }
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'proprtyUnitTable',
        this.count > this.pageSize,
      )
      this.gridOptions.api.sizeColumnsToFit()
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.propertyUnitList = []
      this.selectedRowKeys = []
      this.getCategoryCodes(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.propertyUnitList = []
      this.getCategoryCodes(this.gridOptions)
    },

    getBSUOP() {
      instance
        .get(projectAPIs.dropdown.list(this.$route.params.id, 'bsuop'))
        .then(response => {
          this.bsuopList = []
          this.bsuopList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    getContract() {
      instance
        .get(projectAPIs.dropdown.list(this.$route.params.id, 'contract'))
        .then(response => {
          this.contractList = []
          this.contractList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    addContract(data, id, flag) {
      this.isAddContract = flag
      if (id) {
        this.contractList.push({
          contract: data.contract,
          contractName: data.contractName,
          id: id,
          isActive: data.isActive,
          isLinked: false,
          option: `${data.contract} - ${data.contractName}`,
          value: `${data.contract} - ${data.contractName}`,
        })
        this.contracts.push({
          id: id,
          contract: data.contract,
          contractName: data.contractName,
        })
        this.contractList = _.orderBy(this.contractList, ['contract'], ['asc'])
        this.form.contract = `${data.contract} - ${data.contractName}`
        this.form.mContractDetailsId = id
      }
    },

    onContractChange(value) {
      if (value === 'addContract') {
        this.form.mContractDetailsId = undefined
        this.form.contract = undefined
        this.isAddContract = true
      } else {
        const contract = this.contractList.find(i => i.value === value)
        if (contract) {
          if (contract.id) {
            this.form.mContractDetailsId = contract.id
            this.form.contractDetailsId = undefined
          }
        }
      }
    },

    onChangeBSUOP(value) {
      const bsuop = this.bsuopList.find(i => i.value === value)
      if (bsuop) {
        if (bsuop.id) {
          this.form.mBsuopDetailsId = bsuop.id
          this.form.bsuopDetailsId = undefined
        }
      }
    },

    onChangeAssetClass(value) {
      const assetClass = this.assetClassList.find(i => i.value === value)
      if (assetClass) {
        this.form.assetClass = assetClass.option
        if (assetClass.id) {
          this.form.mAssetClassId = assetClass.id
          this.form.assetClassId = undefined
        }
      }
    },

    // Add categroy code
    addCategoryCode() {
      this.spinner = true
      instance
        .post(projectAPIs.master.categoryCode.add(this.$route.params.id), {
          mAssetClassId: this.form.mAssetClassId,
          mContractDetailsId: this.form.mContractDetailsId,
          mBsuopDetailsId: this.form.mBsuopDetailsId,
          categoryCode: this.form.categoryCode,
          description: this.form.description,
          eligible: this.form.eligible,
          notes: this.form.notes,
          keywords: this.form.keywords,
        })
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Category Code', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Create Category Code',
              'Category Code created successfully!',
            )
            if (this.isAddCategory) {
              this.$emit(
                'addCategory',
                _.get(response.data, 'result', undefined),
                this.contracts,
                false,
              )
            } else {
              this.getCategoryCodes(this.tableParams)
            }
            this.contracts = []
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Update categroy code
    updateCategoryCode() {
      const req = createRequest(
        this.requestKeys,
        this.updateRequest,
        this.form,
      )

      if (!req.isValid) {
        showNotification(
          'info',
          'Update Category Code',
          'No changes found to update!',
        )
        return
      }
      this.spinner = true
      instance
        .patch(
          projectAPIs.master.categoryCode.details(
            this.$route.params.id,
            this.form.id,
          ),
          req.request,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Category Code', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Update Category Code',
              'Category Code updated successfully!',
            )
            const newData = [...this.propertyUnitList]
            const index = newData.findIndex(i => i.id === this.form.id)
            newData[index]['id'] = this.form.id
            newData[index]['description'] = this.form.description
            newData[index]['eligible'] = this.form.eligible
            newData[index]['notes'] = this.form.notes
            newData[index]['keywords'] = this.form.keywords
            if (this.form.assetClass) {
              newData[index]['assetClass'] = this.form.assetClass.split(
                ' - ',
              )[0]
            }
            newData[index]['mAssetClassId'] = this.form.mAssetClassId
            newData[index]['categoryCode'] = this.form.categoryCode
            if (this.form.bsuopName) {
              newData[index]['bsuop'] = this.form.bsuopName.split(' - ')[0]
              newData[index]['bsuopDescription'] = this.form.bsuopName.split(
                ' - ',
              )[1]
            }
            if (this.form.contract) {
              newData[index]['contract'] = this.form.contract.split(' - ')[0]
              newData[index]['contractName'] = this.form.contract.split(
                ' - ',
              )[1]
            }
            this.propertyUnitList = newData
          }
          this.$refs.ruleForm.resetFields()
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i =>
          i.screenId === this.screenId &&
          i.tableName === tableName.project.master.categoryCode,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: this.screenId,
        tableName: tableName.project.master.categoryCode,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },
  },
}
